__turbopack_context__.v({
  "icon": "MenuItem-module__-T4WQa__icon",
  "link": "MenuItem-module__-T4WQa__link",
  "main": "MenuItem-module__-T4WQa__main",
  "selectHover": "MenuItem-module__-T4WQa__selectHover",
  "selected": "MenuItem-module__-T4WQa__selected",
  "selectedBackground": "MenuItem-module__-T4WQa__selectedBackground",
});
